"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicensingObjectType = void 0;
var LicensingObjectType;
(function (LicensingObjectType) {
    LicensingObjectType["UNKNOWN"] = "Unknown";
    LicensingObjectType["PER_DEVICE"] = "PerDevice";
    LicensingObjectType["PER_USER"] = "PerUser";
    LicensingObjectType["PER_MAILBOX_NOT_SUPPORTED"] = "PerMailbox NotSupported";
})(LicensingObjectType || (exports.LicensingObjectType = LicensingObjectType = {}));
